export default __webpack_public_path__ + "static/media/reglogin-bg.fd55cfac.webp";